// import React from "react";
// import { useSelector } from "react-redux";
// import PuffLoader from "react-spinners/PuffLoader";

// function PageSpinner(props) {

//   const { pageSpinners } = useSelector(state => state.spinners);
//   let color = "#1081E8";

//   return (
//     pageSpinners && pageSpinners.length ?
//       <div className="spinner-layer">
//         <div className="sweet-loading">
//           <PuffLoader size={80} color={color} />
//         </div>
//       </div>
//       : null
//   );
// }

// export default PageSpinner;

import React from "react";
import { PuffLoader } from "react-spinners";
import { useSelector } from "react-redux";

function PageSpinner(props) {

  const { pageSpinners } = useSelector(state => state.spinners);
  let color = "#0533B3";

  return (
    pageSpinners && pageSpinners.length ?
      <div className="spinner-layer">
        <div className="sweet-loading">
          <PuffLoader size={80} color={color} />
        </div>
      </div>
      : null
  );
}

export default PageSpinner;